import React from 'react';
import { Color, COLORS } from '../../styles/variables';

interface ChevronUpIconProps {
  size?: number;
  color?: Color;
}

const ChevronUpIcon: React.FC<ChevronUpIconProps> = ({ size = 12, color = COLORS.black }) => (
  <svg width={size} viewBox="0 0 12 6" fill="none">
    <path d="M 0 4 L 6 0 L 12 4" stroke={color} />
  </svg>
);

export default ChevronUpIcon;
